import { IGameState } from '../../State/Store/store';
import {
    BOARD_SHOWN_TRACKS,
    MAP_TRACKS,
    MATCH_TRACKS,
    PRELEVEL_CLOSE_TRACKS,
    PRELEVEL_PLAY_TRACKS,
    PRELEVEL_SHOWN_TRACKS,
    SELECT_TRACKS,
    WIN_AD_TRACKS,
    WIN_DISMISSED_TRACKS,
    WIN_REWARD_TRACKS,
    WIN_SHOWN_TRACKS,
} from '../../Config/Tracking';
import Core from '../../Core/Core';
import { DDNAEvents } from '../../DeltaTracking/Tracker';
import { Tracking } from './Tracking';

export enum FTUE_TRACK_STAGES {
    BOARD_SHOWN,
    WIN_SHOWN,
    WIN_DISMISSED,
    WIN_AD,
    WIN_REWARD,
    TILES_SELECTED,
    TILES_MATCHED,
    MAP_SHOWN,
    PRELEVEL_SHOWN,
    PRELEVEL_CLICK,
    PRELEVEL_DISMISSED,
}

export default class FTUETracking {
    public static track(stage: FTUE_TRACK_STAGES, state: IGameState, id?: string) {
        if (stage === FTUE_TRACK_STAGES.BOARD_SHOWN) {
            this.boardShownTracking(state);
            return;
        }

        if (stage === FTUE_TRACK_STAGES.WIN_SHOWN) {
            this.winScreenShown(state);
            return;
        }

        if (stage === FTUE_TRACK_STAGES.WIN_DISMISSED) {
            this.winDismissed(state);
            return;
        }

        if (stage === FTUE_TRACK_STAGES.WIN_REWARD) {
            this.winReward(state);
            return;
        }

        if (stage === FTUE_TRACK_STAGES.WIN_AD) {
            this.winAd(state);
            return;
        }

        if (stage === FTUE_TRACK_STAGES.TILES_SELECTED) {
            this.tileSelectTracking(state);
            return;
        }

        if (stage === FTUE_TRACK_STAGES.TILES_MATCHED) {
            this.tileMatchTracking(state);
            return;
        }

        if (stage === FTUE_TRACK_STAGES.MAP_SHOWN) {
            this.mapTracking(state);
            return;
        }

        if (stage === FTUE_TRACK_STAGES.PRELEVEL_SHOWN) {
            this.prelevelShown(id, state);
            return;
        }

        if (stage === FTUE_TRACK_STAGES.PRELEVEL_CLICK) {
            this.prelevelClick(id, state);
            return;
        }

        if (stage === FTUE_TRACK_STAGES.PRELEVEL_DISMISSED) {
            this.prelevelClose(id, state);
            return;
        }
    }

    public static boardShownTracking(state: IGameState) {
        this.checkMapEntries(state, BOARD_SHOWN_TRACKS);
    }

    public static winScreenShown(state: IGameState) {
        this.checkMapEntries(state, WIN_SHOWN_TRACKS);
    }

    public static winDismissed(state: IGameState) {
        this.checkMapEntries(state, WIN_DISMISSED_TRACKS);
    }

    public static winReward(state: IGameState) {
        this.checkMapEntries(state, WIN_REWARD_TRACKS);
    }

    public static winAd(state: IGameState) {
        this.checkMapEntries(state, WIN_AD_TRACKS);
    }

    public static tileSelectTracking(state: IGameState) {
        const levelTracks = SELECT_TRACKS.get(state.StateLevel.levelId);
        if (!levelTracks) {
            return;
        }
        levelTracks.forEach(t => {
            if (!state.StateTracking.tracked.includes(t)) {
                // FTUE
                Tracking.addTrack(
                    {
                        event: 'Design',
                        dimension1: t,
                    },
                    true
                );

                if (Core.delta) {
                    Core.delta.addTrackedEvent(DDNAEvents.FTUX);
                }
            }
        });
    }

    public static tileMatchTracking(state: IGameState) {
        const levelTracks = MATCH_TRACKS.get(state.StateLevel.levelId);
        if (!levelTracks) {
            return;
        }

        for (let i = 0; i < levelTracks.length; i++) {
            const t = levelTracks[i];
            if (!state.StateTracking.tracked.includes(t)) {
                // FTUE
                Tracking.addTrack(
                    {
                        event: 'Design',
                        dimension1: t,
                    },
                    true
                );

                if (Core.delta) {
                    Core.delta.addTrackedEvent(DDNAEvents.FTUX);
                }

                break;
            }
        }
    }

    public static mapTracking(state: IGameState) {
        this.checkMapEntries(state, MAP_TRACKS);
    }

    public static prelevelShown(id: string, state: IGameState) {
        this.checkMapEntries(state, PRELEVEL_SHOWN_TRACKS, id);
    }

    public static prelevelClose(id: string, state: IGameState) {
        this.checkMapEntries(state, PRELEVEL_CLOSE_TRACKS, id);
    }

    public static prelevelClick(id: string, state: IGameState) {
        this.checkMapEntries(state, PRELEVEL_PLAY_TRACKS, id);
    }

    public static checkMapEntries(state: IGameState, m: Map<string, string>, id?: string) {
        for (const [key, value] of m.entries()) {
            const checkId = id || state.StateLevel.levelId;
            if (checkId === key) {
                if (!state.StateTracking.tracked.includes(value)) {
                    // FTUE
                    Tracking.addTrack(
                        {
                            event: 'Design',
                            dimension1: value,
                        },
                        true
                    );
                    if (Core.delta) {
                        Core.delta.addTrackedEvent(DDNAEvents.FTUX);
                    }
                }
            }
        }
    }
}
